const waitFor = func => {
  return new Promise(resolve => {
    var interval = setInterval(() => {
      if (func()) {
        clearInterval(interval);
        resolve();
      }
    }, 15);
  });
};

export default waitFor;
